var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconComment = function SvgIconComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 9h.01M10 9h.01M14 9h.01M19 9c0 4.418-4.03 8-9 8a9.9 9.9 0 0 1-4.255-.949L1 17l1.395-3.72C1.512 12.042 1 10.574 1 9c0-4.418 4.03-8 9-8s9 3.582 9 8"
  })));
};
export default SvgIconComment;